import { render, staticRenderFns } from "./ControlPanelLottie.vue?vue&type=template&id=253b1b27&scoped=true"
import script from "./ControlPanelLottie.vue?vue&type=script&lang=js"
export * from "./ControlPanelLottie.vue?vue&type=script&lang=js"
import style0 from "./ControlPanelLottie.vue?vue&type=style&index=0&id=253b1b27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b1b27",
  null
  
)

export default component.exports